import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import TextField from '@mui/material/TextField';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { getIn } from "formik";
import DeleteIcon from '@mui/icons-material/Delete';
import NumberFormatCustom from '../../common/form/NumberFormatCustom';
import TechCostTyp from '../../common/form/selectbox/TechCostTyp';

const RsltCostForm = ({ formik, index, cost, handleRemove }) => {
    const costTyp = `rsltCosts[${index}].costTyp`;
    const touchedCostTyp = getIn(formik.touched, costTyp);
    const errorCostTyp = getIn(formik.errors, costTyp);




    const costVal = `rsltCosts[${index}].costVal`;
    const touchedCostVal = getIn(formik.touched, costVal);
    const errorCostVal = getIn(formik.errors, costVal);

    const costDesc = `rsltCosts[${index}].costDesc`;
    const touchedCostDesc = getIn(formik.touched, costDesc);
    const errorCostDesc = getIn(formik.errors, costDesc);


    return (
        <TableRow key={index}>
            <TableCell>{index + 1}</TableCell>
            <TableCell >
                <TechCostTyp
                    index={index}
                    formik={formik}
                    touched={touchedCostTyp}
                    errored={errorCostTyp}
                    filterObject={{
                        blcCd: 'BASE',
                        mlcCd: 'TECH',
                        slcCd: 'COST_TYP',
                    }}
                    fullWidth
                    variant="standard"
                    required
                    name="costTyp"

                />
            </TableCell>
            <TableCell>
                <TextField
                    size="small"
                    required
                    variant="standard"
                    fullWidth
                    name={costVal}
                    value={formik.values.rsltCosts[index].costVal}
                    helperText={
                        touchedCostVal && errorCostVal
                            ? errorCostVal
                            : ""
                    }
                    error={Boolean(touchedCostVal && errorCostVal)}
                    onChange={(e) =>
                        formik.setFieldValue(costVal, e.target.value)
                    }
                    onBlur={formik.handleBlur}
                    InputProps={{
                        inputComponent: NumberFormatCustom,
                    }}
                />
            </TableCell>
            <TableCell >
                <TextField
                    size="small"
                    required
                    variant="standard"
                    fullWidth
                    name={costDesc}
                    id={costDesc}
                    value={formik.values.rsltCosts[index].costDesc}
                    helperText={
                        touchedCostDesc && errorCostDesc
                            ? errorCostDesc
                            : ""
                    }
                    error={Boolean(touchedCostDesc && errorCostDesc)}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                />
            </TableCell>
            <TableCell>
                <IconButton aria-label="delete" onClick={handleRemove}><DeleteIcon /></IconButton>
            </TableCell>
        </TableRow>
    )
}

export default RsltCostForm